// extracted by mini-css-extract-plugin
export var cdsAssistiveText = "ExpressiveListContainer-module--cds--assistive-text--f0b46";
export var cdsHideFeedback = "ExpressiveListContainer-module--cds--hide-feedback--cc7a4";
export var cdsShowFeedback = "ExpressiveListContainer-module--cds--show-feedback--fe070";
export var cdsSkeleton = "ExpressiveListContainer-module--cds--skeleton--99c46";
export var cdsVisuallyHidden = "ExpressiveListContainer-module--cds--visually-hidden--99595";
export var container = "ExpressiveListContainer-module--container--9a6be";
export var content = "ExpressiveListContainer-module--content--9c8e8";
export var expressive_02 = "ExpressiveListContainer-module--expressive_02--67ef2";
export var expressive_04 = "ExpressiveListContainer-module--expressive_04--c1003";
export var text = "ExpressiveListContainer-module--text--6d506";
export var title = "ExpressiveListContainer-module--title--8b410";